import { render } from "./comment-form.vue?vue&type=template&id=0079b780"
import script from "./comment-form.vue?vue&type=script&lang=js"
export * from "./comment-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__